import { some } from 'lodash/fp';

import { Offer } from '../../../../components/offers/types';
import { TARGET_SEGMENT } from '../../../../cms/constants';

const isPartnerOffer = (offer: Offer) =>
  some(
    (segment) => segment?.identifier?.current === TARGET_SEGMENT.PARTNER_LOOKING_FOR_PRIVATE_HEALTH_INSURANCE,
    offer?.targetsSegments,
  );

export default isPartnerOffer;
